var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',{attrs:{"title":"供应链统计"}},[_c('scm-data'),_c('scm-time-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }